import { DefaultButton, Dialog, DialogFooter, DialogType, IDialogProps } from "@fluentui/react";
import React from "react";

import { Stack } from "../../../components/layouts/stack/Stack";
import { PrimaryButton } from "../../inputs/button/PrimaryButton";

export type ConfirmDialogProps = Pick<IDialogProps, "hidden"> & {
    title: string;
    text: string;
    isBlocking?: boolean;
    showCloseButton?: boolean;
    width?: number | string;
    contentHeight?: number;
    confirm: {
        onClick(): void | Promise<void>;
        buttonText?: string;
        disabled?: boolean;
    };
    cancel?: {
        onClick(): void | Promise<void>;
        buttonText?: string;
        disabled?: boolean;
    };
};

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    title,
    text,
    hidden,
    isBlocking,
    showCloseButton,
    width,
    contentHeight,
    children,
    confirm,
    cancel
}) => {
    const handleCancel = async () => {
        if (cancel) {
            await cancel.onClick();
        }
    };

    const handleConfirm = async () => {
        await confirm.onClick();
    };

    return (
        <Dialog
            dialogContentProps={{
                type: DialogType.normal,
                title: title,
                subText: text,
                styles: { subText: { marginBottom: 15 } },
                showCloseButton
            }}
            modalProps={{ isBlocking }}
            hidden={hidden || false}
            onDismiss={handleCancel}
            minWidth={width}
        >
            {children && (
                <Stack styles={{ root: { maxHeight: contentHeight, overflowY: "auto", overflowX: "auto" } }}>
                    {children}
                </Stack>
            )}

            <DialogFooter styles={{ actions: { lineHeight: 0, marginTop: 0 } }}>
                <Stack horizontal={true} horizontalAlign="end" tokens={{ childrenGap: 10, padding: 10 }}>
                    <DefaultButton
                        onClick={handleCancel}
                        text={cancel?.buttonText ?? "Cancel"}
                        disabled={cancel?.disabled}
                        data-testId="confirm-dialog-cancel-button"
                    />
                    <PrimaryButton
                        onClick={handleConfirm}
                        text={confirm.buttonText ?? "Confirm"}
                        disabled={confirm?.disabled}
                        testId="confirm-dialog-confirm-button"
                        type="loading"
                    />
                </Stack>
            </DialogFooter>
        </Dialog>
    );
};
